import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactResizeDetector from 'react-resize-detector';
import ContentTitle from '../content-title/ContentTitle';
import ContentDetail from '../content-detail/ContentDetail';

class ContentDescription extends Component {
  static propTypes = {
    engName: PropTypes.string.isRequired,
    chtName: PropTypes.string.isRequired,
    engContent: PropTypes.string.isRequired,
    chtContent: PropTypes.string.isRequired,
    infos: PropTypes.object.isRequired,
    onHeightCalculated: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.onHeightCalculated()
  }

  onResize() {
    this.onHeightCalculated()
  }

  onHeightCalculated() {
    const { onHeightCalculated } = this.props;
    onHeightCalculated(this.div.clientHeight);
  }

  render() {
    const {
      engName,
      chtName,
      engContent,
      chtContent,
      infos,
    } = this.props;

    return (
      <div>
        <ReactResizeDetector handleWidth handleHeight onResize={this.onResize.bind(this)} />
        <div ref={(div) => { this.div = div; }}>
          <ContentTitle
            engName={engName}
            chtName={chtName}
          />
          <ContentDetail
            engContent={engContent}
            chtContent={chtContent}
            infos={infos}
          />
        </div>
      </div>
    );
  }
}

export default ContentDescription;



// WEBPACK FOOTER //
// ./src/components/content-description/ContentDescription.js